<div class="entityItem">
  <div class="removeEntity" (click)="removeItem()">
    <svg xmlns="http://www.w3.org/2000/svg" width="23.118" height="23.118" viewBox="0 0 23.118 23.118">
      <circle id="Ellipse_35" data-name="Ellipse 35" [attr.fill]="'white'" cx="9.5" cy="9.5" r="9.5" transform="translate(2 2)"/>
      <!--        TODO change for proper color-->
      <!--      <circle id="Ellipse_35" data-name="Ellipse 35" [attr.fill]="data.contrastColor" cx="9.5" cy="9.5" r="9.5" transform="translate(2 2)"/>-->
      <g id="Button-Close-Windows">
        <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" [attr.fill]="'#0BD454'" d="M14.934,3.375A11.559,11.559,0,1,0,26.493,14.934,11.519,11.519,0,0,0,14.934,3.375Zm5.78,15.72L19.1,20.713l-4.161-4.161-4.161,4.161L9.154,19.1l4.161-4.161L9.154,10.773l1.618-1.618,4.161,4.161L19.1,9.155l1.618,1.618-4.161,4.161Z" transform="translate(-3.375 -3.375)"/>
        <!--        TODO change for proper color-->
        <!--        <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" [attr.fill]="data.mainColor" d="M14.934,3.375A11.559,11.559,0,1,0,26.493,14.934,11.519,11.519,0,0,0,14.934,3.375Zm5.78,15.72L19.1,20.713l-4.161-4.161-4.161,4.161L9.154,19.1l4.161-4.161L9.154,10.773l1.618-1.618,4.161,4.161L19.1,9.155l1.618,1.618-4.161,4.161Z" transform="translate(-3.375 -3.375)"/>-->
      </g>
    </svg>
  </div>
  <div (click)="onJumpTo()" class="entityImage">
    <img [src]="data.img | secure | async" default="./assets/ui/png/loading_small.png" >
  </div>
  <span class="entityName">
    {{data.label}}
  </span>
</div>
